import React, { FC } from "react";
import clsx from "clsx";
import {
  CameraIcon,
  CrossSmallIcon,
  HeadIcon,
  LegsIcon,
  RootIcon,
  ShoesIcon,
  TorsosIcon,
} from "@/shared/icons";
import { BaseIconProps } from "@/shared/icons/BaseIcon";
import { Button } from "@/shared/ui";
import { AuthCamera } from "@/domains/createCharacter/constants/authCamera";

type Props = {
  variants: AuthCamera[];
  value: string;
  setValue: (value: string) => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

const iconVariant: Record<AuthCamera, FC<BaseIconProps>> = {
  [AuthCamera.Head]: HeadIcon,
  [AuthCamera.Torsos]: TorsosIcon,
  [AuthCamera.Legs]: LegsIcon,
  [AuthCamera.Shoes]: ShoesIcon,
  [AuthCamera.Root]: RootIcon,
};

export default function CreateCharacterCamera({
  variants,
  value,
  setValue,
  isOpen,
  setIsOpen,
}: Props) {
  return (
    <div className="absolute bottom-10 right-[--customization-side-w] mr-10  overflow-hidden flex items-center rounded-2xl bg-canvas">
      <div
        className={clsx(
          "flex gap-1 overflow-hidden transition-[width] py-1 ease-in-out",
          isOpen ? "w-[calc(var(--count)*3rem+.25rem*var(--count))]" : "w-0",
        )}
        style={{ "--count": variants.length } as React.CSSProperties}
      >
        <div />
        {variants.map((variant) => {
          return (
            <Button
              key={variant}
              variant={value === variant ? "solid-gradient" : "soft"}
              color="gray"
              className="h-12"
              noninteractive={value === variant}
              icon
              onClick={() => setValue(variant)}
            >
              {iconVariant[variant]({ size: 26 })}
            </Button>
          );
        })}
      </div>
      <Button
        className="h-12 mx-1"
        icon
        variant="ghost"
        color="gray"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <CrossSmallIcon size={10} /> : <CameraIcon size={24} />}
      </Button>
    </div>
  );
}
